import styled from 'styled-components';

export const Counter = styled.div`
  display: flex;
  align-items: center;
`;

export const Btn = styled.button`
  background: none;
  border: none;
  line-height: 0;
  cursor: pointer;

  &:disabled {
    opacity: 0.3;
    pointer-events: none;
  }

  &:focus {
    outline: none;
  }
`;

export const Input = styled.input`
  width: 54px;
  border-radius: 4px;
  border: 1px solid var(--aluminium60);
  background: var(--white);
  height: 30px;
  padding: 5px 12px;
  margin: 0 7px;
  &:focus {
    outline: none;
  }
`;
